<section class="ecommerce-customers-wrapper">
  <div class="fake-mode-cover" *ngIf="isFakeMode"></div>
  <div class="customers__mange-actions">
    <div>
      <ds-search-input class="customers__mange-actions-search"
                       [formControl]="searchTerm"
                       [showLoading]="showSearchLoading"
                       [placeholder]="'text_searchByEmail' | dbText"
                       [hasSearchIcon]="true"></ds-search-input>
    </div>
  </div>
  <section class="customers-table-wrapper">
    <db-customers-table>
      <ng-container>
        <ng-container *ngIf="customers?.length; else emptyTable">
          <div class="list">
            <db-customers-table-row *ngFor="let customer of customers"
                                    (removeItem)="onRemoveItem($event)"
                                    [customer]="customer">
            </db-customers-table-row>
          </div>
          <div class="pagination-wrapper" *ngIf="!searched">
            <ds-pagination-controls [itemsCount]="customersCount"
                                    [rightNavigation]="false"
                                    [itemsPerPage]="customersPerPage"
                                    [currentPage]="currentPage"
                                    (onChangePage)="changePage($event)">
            </ds-pagination-controls>
          </div>
        </ng-container>
        <ng-template #emptyTable>
          <div class="empty-table"
               *ngIf="!loading">
            <span>{{(searchTerm?.value?.length ? 'text_productsNoMatch' : 'text_customersNoCustomer')|dbText}}</span>
          </div>
        </ng-template>
      </ng-container>
      <db-loading-screen [ngClass]="{'hidden':!loading}"></db-loading-screen>
    </db-customers-table>
  </section>

</section>
